var observer = new MutationObserver(function(mutations) {
  for (let i = 0; i < mutations.length; i++) {
    if (
      document.querySelector('#royalty-header .header-logos .header-logos-rendered') &&
      document.querySelector('#header .header-logos .header-logos-rendered') &&
      document.querySelector('#ymig-header .header-logos .header-logos-rendered')
    ) {
      observer.disconnect();
      executeScript();
      break;
    }
  }
});

observer.observe(document.body, { childList: true, subtree: true });

var activeHeaderParam = new URLSearchParams(window.location.search)
var activeHeader = activeHeaderParam.get('active_header') || sessionStorage.getItem('active_header');

var royaltyHeader, defaultHeader, ymigHeader;

function setActiveLogo(activeHeader) {
  document.querySelectorAll('.logo').forEach(logo => {
    logo.classList.remove('active');
    if (activeHeader === 'royalty' && logo.classList.contains('rfm-logo')) {
      logo.classList.add('active');
    }
    if (activeHeader === 'ymig' && logo.classList.contains('ymig-logo')) {
      logo.classList.add('active');
    }
    if ((activeHeader === 'default' || activeHeader === null) && logo.classList.contains('ymi-logo')) {
      logo.classList.add('active');
    }
  });
}

function claimLandmarkIds(activeWrapper) {
  document.querySelectorAll('#header, #royalty-header, #ymig-header').forEach(function(wrapper) {
    var active = wrapper === activeWrapper;
    wrapper.querySelectorAll('[data-landmark]').forEach(function(el) {
      var id = el.getAttribute('data-landmark');
      if (!id) return;
      if (active) el.id = id;
      else if (el.id) el.removeAttribute('id');
    });
  });
}

function toggleHeaderVisibility(element, show) {
  if (element) {
    element.style.display = show ? 'block' : 'none';
    element.classList.toggle('active-header', show);
    if (show) claimLandmarkIds(element);
    document.dispatchEvent(new Event('header:toggle'))
  }
}

function switchHeaders(headerToActivate) {
  if (!headerToActivate ||  headerToActivate === 'null') {
    headerToActivate = 'default'
  }

  sessionStorage.setItem('active_header', headerToActivate);

  toggleHeaderVisibility(royaltyHeader, headerToActivate === 'royalty');
  toggleHeaderVisibility(defaultHeader, headerToActivate === 'default');
  toggleHeaderVisibility(ymigHeader, headerToActivate === 'ymig');
}

function addLogoEventListeners() {
  document.querySelectorAll('.active-header').forEach(header => {
    header.addEventListener('click', function(event) {
      const clickedLogo = event.target.closest('.logo');
      if (!clickedLogo) return;

      if (clickedLogo.classList.contains('ymig-logo')) {
        switchHeaders('ymig');
      } else if (clickedLogo.classList.contains('ymi-logo')) {
        switchHeaders('default');
      } else if (clickedLogo.classList.contains('rfm-logo')) {
        switchHeaders('royalty');
      }
    });
  });
}
function setupCollapsible(triggerSelector, sublistSelector, parentSelector) {
  document.querySelectorAll(triggerSelector).forEach(function(trigger) {
      trigger.addEventListener('click', function() {
          const parentItem = this.closest(parentSelector);

          const allSublists = document.querySelectorAll(sublistSelector);
          allSublists.forEach(function(sublist) {
              if (!parentItem.contains(sublist)) {
                  sublist.classList.remove('is-open');
                  sublist.style.height = '0';
              }
          });

          const allTriggers = document.querySelectorAll(triggerSelector);
          allTriggers.forEach(function(btn) {
              if (btn !== trigger) {
                  btn.classList.remove('is-open');
              }
          });

          var currentSublist = parentItem.querySelector(sublistSelector);
          var isOpen = currentSublist.classList.toggle('is-open');
          currentSublist.style.height = isOpen ? currentSublist.scrollHeight + 'px' : '0';

          if(isOpen){
              setTimeout(() => {
                  parentItem.scrollIntoView({ behavior: 'smooth', block: 'start' });
              }, 300);
          }
    });
  });
}

function executeScript() {
  royaltyHeader = document.getElementById('royalty-header');
  defaultHeader = document.getElementById('header');
  ymigHeader = document.getElementById('ymig-header');

  if (activeHeader === 'royalty') {
    toggleHeaderVisibility(royaltyHeader, true);
  } else if (activeHeader === 'ymig') {
    toggleHeaderVisibility(ymigHeader, true);
  } else {
    toggleHeaderVisibility(defaultHeader, true);
  }

  if (document.location.href.includes('pages/royaltyforme')) {
    switchHeaders('royalty');
  } else if (document.location.href.includes('pages/girls')) {
    switchHeaders('ymig');
  } else {
    switchHeaders(activeHeader);
  }

  addLogoEventListeners();
  setActiveLogo(activeHeader);
  setupCollapsible('.active-header .mobile-mega_grand-sub .collapsible-trigger', '.mobile-nav__grandsublist', '.mobile-nav__item');
  setupCollapsible('.active-header .mobile-nav__toggle .collapsible-trigger', '.mobile-mega_child_nav', '.mobile-nav__item');
}
